// @ts-nocheck

import { createSelector } from 'reselect';

import { selectMultiviewMode } from '../../selectors/multiview/multiviewPrimary.selector';
import { selectRuntimeIsWTVEnabled, selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import {
  selectUserConnected,
  selectUserJwtToken,
  selectUserRealMoney,
  selectUserSessionId,
} from '../../selectors/user/userPrimary.selector';

const selectDesktopLayoutProps = createSelector(
  [
    selectUserConnected,
    selectMultiviewMode,
    selectRuntimeLicence,
    selectUserJwtToken,
    selectUserRealMoney,
    selectUserSessionId,
    selectRuntimeIsWTVEnabled,
  ],
  (connected, isExpanded, licence, jwt, realMoney, sessionId, isWTVEnabled) => ({
    connected,
    isExpanded,
    licence,
    jwt,
    realMoney,
    sessionId,
    isWTVEnabled,
  }),
);

export default selectDesktopLayoutProps;
